import React, {Component} from 'react'
import {Button, Form, Row, Col, Input, Table, Modal} from 'antd'
import {toJS} from 'mobx'
import {DeleteOutlined, QuestionCircleFilled, SearchOutlined, PlusOutlined} from '@ant-design/icons'
import businessTypeAPI from '../../apis/businessType'
import {getPaginationConfig} from '../../components/pagination'
import FormModal from './FormModal'
import UPM from '../../constants/urlPermissionMappings'
import {withTranslation} from 'react-i18next'

const {confirm} = Modal

class businessType extends Component {
  state = {
    page: 1, // 当前页
    size: 10, // 每页显示条数
    total: null, // 总条数
    addModalVisible: false,
    tableData: []
  }
  formRef = React.createRef()

  componentDidMount() {
    this.handleSearch(1, 10)
  }

  handleSearch = (page, size) => {
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        businessType: fieldsValue.businessType,
        page: page ? page : this.state.page,
        size: size ? size : this.state.size,
      }
      businessTypeAPI.searchAction(params).then(res => {
        this.setState({
          tableData: res.data.data?.records,
          page: res.data.data.current, // 当前页
          size: res.data.data.size, // 每页显示条数
          total: res.data.data.total // 总条数
        })
      })
    }).catch()
  }

  handleCreate = () => {
    this.setState({
      addModalVisible: true
    })
  }

  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }

  handlePageChange = (page, pageSize) => {
    // page 目标页
    // pageSize 显示条数
    this.handleSearch(page, pageSize)
  }

  handleDel = (record) => {
    const {t} = this.props
    let _this = this
    confirm({
      title: t(`general.deleteData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToDelete`),
      okText: t(`general.delete`),
      cancelText: t(`general.cancel`),
      onOk() {
        businessTypeAPI.delAction(record.id).then(() => {
          _this.handleSearch()
        })
      },
      onCancel() {
        console.log('Cancel')
      },
    })
    return false
  }

  getRowClassName = (record, index) => {
    let className
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  render() {
    const {location, t} = this.props
    const pagination = getPaginationConfig(this.state.page, this.state.size, this.state.total, this.handlePageChange)

    return (
      <div className="container">
        <Form ref={this.formRef} size="middle" className="searchForm" layout="vertical">
          <div className="searchFormTitle">
            <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
          </div>
          <Row gutter={[10, 0]}>
            <Col span={6}>
              <Form.Item name="businessType" label={t(`businessType.businessType`)}>
                <Input placeholder={t(`general.pleaseEnter`)} allowClear/>
              </Form.Item>
            </Col>
            <Col span={18} style={{textAlign: 'right', marginTop: 30}}>
              <Button onClick={() => { this.handleSearch(1, 10) }} type='danger'>{t(`general.search`)}</Button>
              <Button onClick={this.handleCreate} type="primary" icon={<PlusOutlined/>}>{t(`general.add`)}</Button>
            </Col>
          </Row>
        </Form>

        <Table className="searchResult" dataSource={toJS(this.state.tableData)} rowKey="id" pagination={pagination}
               rowClassName={this.getRowClassName}>
          <Table.Column title={t(`businessType.businessType`)} dataIndex="businessType" key="businessType" ellipsis={true}/>
          <Table.Column title={t(`businessType.creator`)} dataIndex="createUser" key="createUser" ellipsis={true}/>
          <Table.Column title={t(`businessType.createTime`)} dataIndex="createTime" key="createTime" ellipsis={true}/>
          <Table.Column width={200} align="center" title={t(`general.action`)} key="Action" render={(text, record) => (
            <>
              <Button type="link" onClick={() => this.handleDel(record)} icon={<DeleteOutlined/>} title={t(`general.delete`)}/>
            </>
          )}/>
        </Table>

        {this.state.addModalVisible ?
          <FormModal handleCancel={this.handleCancel} handleSearch={this.handleSearch} addModalVisible={this.state.addModalVisible}/> : null}
      </div>
    )
  }
}

export default withTranslation()(businessType)
